import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppComponent } from './app.component';
import { RouterModule, Routes } from '@angular/router';
import { ApprovalsModule } from './approvals/approvals.module';
import { LayoutModule } from './layout/layout.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { HomeComponent } from '../app/home/home.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MainLayoutComponent } from '../app/layout/main-layout/main-layout.component';
import { CallbackComponent } from './callback/callback.component';
import { CatalogListComponent } from './catalog-list/catalog-list.component';
import { AllApplicationsComponent } from './all-applications/all-applications.component';
import { AuthenticationComponent } from './authentication/authentication.component';
import { AuthorizationService } from './services/authorization.service';
import { environment } from '../environments/environment';
import { AuthorizationConfig } from './services/authorization_config';
import { Requestor,FetchRequestor } from '@openid/appauth';
import { FilterPipe } from './services/filterpipe';
import { NgxPaginationModule } from 'ngx-pagination';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ToastrModule } from 'ngx-toastr';
import { CweditsectionComponent } from './cweditsection/cweditsection.component';
import { TableModule } from 'primeng/table';
import { LoginComponent } from './login/login.component';
import { ToasterContainerComponent } from './toaster/toaster-container.component';
import { ToasterComponent } from './toaster/toaster.component';
import { ToasterService } from './toaster/toaster.service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { HeaderComponent } from './header/header.component';
import { SupportComponent } from './support/support.component';
import { ReloadComponent } from './reload/reload.component';
import { BnNgIdleService } from 'bn-ng-idle';


import { HttpClient } from "@angular/common/http";
// import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
// import { TranslateHttpLoader } from "@ngx-translate/http-loader";


// export function HttpLoaderFactory(http: HttpClient) {
//     return new TranslateHttpLoader(http);
//     //return new TranslateHttpLoader(http, "/mw/assets/i18n/", ".json");
//   }

const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    /*{
        path: 'dashboard', component: MainLayoutComponent,
        children: [{ path: '', component: DashboardComponent }]
    },*/
    {
        path: 'callback', component: MainLayoutComponent,
        children: [{ path: '', component: CallbackComponent }]
    },
    {
        path: 'testresult', component: MainLayoutComponent,
        children: [{ path: '', component: CallbackComponent }]
    },
    /*{
        path: 'AppCatalog', component: MainLayoutComponent,
        children: [{ path: '', component:CatalogListComponent }]
    }*/
    /*{
        path: 'allappln', component: MainLayoutComponent,
        children: [{ path: '', component: AllApplicationsComponent }]
    },*/
    /*{
        path: 'MyApps', component: MainLayoutComponent,
        children: [{ path: '', component:HomeComponent }]
    }*/
    {
        path: 'home', component: MainLayoutComponent,
        children: [
            { path: '', component: HomeComponent },
            {path:'AppCatalog',component:CatalogListComponent}
        ]
    },
    {
        path: 'authentication', component: MainLayoutComponent,
        children: [
            { path: '', component: AuthenticationComponent }
        ]
    },
    {
        path:'login',component:LoginComponent
    },
    {path:'Edit',component:CweditsectionComponent},
    {path:'Terms',component:SupportComponent}  ,
    {path:'reload',component:ReloadComponent}   
];

@NgModule({
    declarations: [
        AppComponent,
        CallbackComponent,
        CatalogListComponent,
        AllApplicationsComponent, DashboardComponent,
        AuthenticationComponent, HomeComponent, FilterPipe, CweditsectionComponent, LoginComponent,
        ToasterContainerComponent, ToasterComponent, HeaderComponent, SupportComponent, ReloadComponent
    ],
    imports: [
        BrowserModule, CommonModule,
        RouterModule.forRoot(routes,{ relativeLinkResolution: 'legacy',useHash:true }),
        LayoutModule,
        ApprovalsModule,
        HttpClientModule,
        FormsModule,ReactiveFormsModule,ToastrModule.forRoot(),
        BrowserAnimationsModule, NgxPaginationModule,
        ModalModule.forRoot(),
        TableModule,NgxSpinnerModule,
        // TranslateModule.forRoot({
        //   defaultLanguage: 'en',
        //   loader: {
        //     provide: TranslateLoader,
        //     useFactory: HttpLoaderFactory,
        //     deps: [HttpClient]
        //   }
        // })
    ],    
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [AuthorizationService, BnNgIdleService,{ provide: Requestor, useValue: new FetchRequestor() },
        { provide: 'AuthorizationConfig', useValue: environment }],
    bootstrap: [AppComponent]
})
export class AppModule { }